export const setSectionsUnlocked = (familyData, sectionsUnlocked) => {
  if (familyData.depends) {
    sectionsUnlocked.push('depends', 'dependency')
  }
  if (familyData.disability) {
    sectionsUnlocked.push('disability', 'disabilityinput')
  }
  return sectionsUnlocked
}
